// Decorative `alt=""` — callers pair with a visible "Medceptor" wordmark.
export function Logo({ size }: { size: number }) {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img src="/logo.svg" alt="" width={size} height={size} />
  );
}
